export default __webpack_public_path__ + "static/media/direct_quotes.4658f0eb.svg";